import dayjs from "dayjs"
import { GetRecentCustomerReferralsQuery } from "@/api/hasura/generated/graphql"
import { getReferralCodeFromCustomerNumber } from "@/helpers/referralHelper"
import { Referral } from "./referral"

export const parseReferral = (
  referral: GetRecentCustomerReferralsQuery["customer_referrals"][number],
) =>
  new Referral(
    getReferralCodeFromCustomerNumber(referral.referee.number),
    dayjs(referral.created_at),
    referral.referee.customer_user_rels[0]?.user_id,
    referral.referee.billing_accounts[0]?.number,
    referral.referee.customer_user_rels.find((rel) => rel.user?.email)?.user
      ?.email ?? "",
  )
